// extracted by mini-css-extract-plugin
module.exports = {"container":"Statistics_container__3KRL9","graph":"Statistics_graph__2pY2s","label":"Statistics_label__3_Et_"};